import TextField from '@components/atoms/TextField'
import PopUpBottom from '@components/organisms/PopUpBottom'
import { FormFieldHeight, colors, fontFamilies } from '@configs/styles/config'
import styled from '@emotion/styled'
import { BottomNotification } from '@type/main'
import { ErrorMessage, Field, FieldProps, Form, Formik } from 'formik'

import {
  // FormEvent,
  useEffect, // useRef,
  useState,
} from 'react'

import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
// import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import UpdateUser from '@services/api/user/updateUser'
// import OtpInput from 'react-otp-input'
import { verifyAuthorUsername } from '@services/api/user'
import Loader from '@components/organisms/Loader'
// import CButton from '@components/atoms/Button'
import {
  Button,
  Checkbox,
  Switch,
  Modal,
  ModalHeader,
  ModalContent,
  ModalBody,
} from '@nextui-org/react-latest'
// import { RecaptchaVerifier, linkWithPhoneNumber } from 'firebase/auth'
// import { auth } from '@configs/firebase'
import { useAuth } from '@contexts/Auth'
import { debounce } from 'lodash'
import CheckMarkIcon from '@public/static/icons/checkmark-icon'
import CrossCircleIcon from '@public/static/icons/cross-circle-icon'
import { useToaster } from '@hooks/useToaster'
import { logEvent } from 'firebase/analytics'
import { analytics } from '@configs/firebase'
import dynamic from 'next/dynamic'
const BecomeAuthor = dynamic(() => import('@public/static/icons/become-auther'))

type ModalProps = {
  isOpen: boolean
  onClose: (ask?: boolean) => void
  onSuccess?: () => void
}
const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px 20px;
  gap: 10px;
  @media (max-width: 1055px) {
    flex-direction: column;
  }
`
const Left = styled.div`
  flex: 1;
  @media (max-width: 625px) {
    transform: scale(0.7);
  }
  @media (max-width: 1055px) {
    margin: auto;
  }
`
const Right = styled.div`
  flex: 1;
`
const Heading = styled.div`
  font-family: ${fontFamilies.bold};
  text-align: center;
  margin-bottom: 14px;
  letter-spacing: 0rem;
  font-size: 1.2rem;
  max-width: 20rem;
`
const InputFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: start;
  @media (max-width: 1055px) {
    align-items: center;
  }
`
const InputField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const Error = styled.p`
  color: ${colors.uguRed};
  text-align: left;
  font-size: 13px;
  font-family: ${fontFamilies.regular};
  letter-spacing: 0rem;
`
const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: ${(props) => props.marginBottom};
  margin-left: ${(props) => props.marginLeft};

  label {
    z-index: 0 !important;
  }
`
const SwitchText = styled.span`
  font-size: 14px;
`
// const OtpContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   padding: 20px;
//   align-items: center;
//   gap: 6px;
// `
// const Text = styled.p`
//   text-align: center;
//   font-size: 13px;
//   font-weight: 500;
// `
// const OtpInputField = styled.input`
//   border: none;
//   outline: none;
//   border-bottom: 4px solid #7181ff;
//   /* border-bottom-left-radius: 2px;
//     border-bottom-right-radius: 2px; */
//   font-size: 30px;
//   font-weight: 600;
//   color: #5e71ff;
// `
const Input = styled.input<{ width: string }>`
  border: 1px solid ${(props) => (props.error ? colors.uguRed : 'lightgray')};
  border-radius: 10px;
  padding: ${(props) => (props.padding ? props.padding : '0 1.5rem')};
  height: ${FormFieldHeight.large};
  width: ${(props) => props.width};
  :focus {
    border: 2px solid #7181ff;
  }
`
interface Values {
  author_type?: 'individual' | 'organization'
  author_first_name?: string
  author_last_name?: string
  author_organization?: string
  author_URL?: string
  // mobile?: number
}

const regexForUsername = /^[a-zA-Z0-9_]+$/

const AuthorDetailsModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  const { updateUser, user } = useAuth()
  const { t } = useTranslation(['author', 'becomeAuthorDetailsModal'])
  // const appVerifier = useRef<RecaptchaVerifier | null>(null)
  const [bottomNotification, setBottomNotification] = useState<
    boolean | BottomNotification
  >(false)
  // const [mobile, setMobile] = useState<string | null>(null)
  const [instructorType, setInstructorType] = useState<Boolean>(false)
  const [isAgreed, setIsAgreed] = useState<Boolean>(false)
  // const [isOTPAvailable, setIsOTPAvailable] = useState<unknown>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  // const [otp, setOtp] = useState<string>('')
  const [secondsLeftBeforeNextResend, setSecondsLeftBeforeNextResend] =
    useState(0)
  // const [firebaseVerificationHandler, setFirebaseVerificationHandler] =
  //   useState<any>()
  const [isUsernameAvailable, setIsUsernameAvailable] = useState<boolean>(false)
  const [isLoadingUsername, setIsLoadingUsername] = useState<boolean>(false)
  // const [isInvalidOTP, setIsInvalidOTP] = useState(false)
  const { toaster } = useToaster()

  const initialValues: Values = {
    author_type: 'individual',
    author_first_name: user?.first_name || '',
    author_last_name: user?.last_name || '',
    author_organization: '',
    author_URL: user && user.username ? user.username.replace(/\./g, '') : '',
  }
  // const OTPValidationErrorMsgs = {
  //   unknown: t('messages.unableToVerifyOTP', {
  //     ns: 'becomeAuthorDetailsModal',
  //   }),
  //   'invalid-verification-code': t('messages.invalidOTP', {
  //     ns: 'becomeAuthorDetailsModal',
  //   }),
  //   'internal-error': t('messages.internalOTPError', {
  //     ns: 'becomeAuthorDetailsModal',
  //   }),
  //   'too-many-requests': t('messages.OTPTooManyRequests', {
  //     ns: 'becomeAuthorDetailsModal',
  //   }),
  //   'code-expired': t('messages.codeExpired', {
  //     ns: 'becomeAuthorDetailsModal',
  //   }),
  //   'account-exists-with-different-credential': t(
  //     'messages.accountExistMessage',
  //     {
  //       ns: 'becomeAuthorDetailsModal',
  //     }
  //   ),
  //   'provider-already-linked': t('messages.linkedProvider', {
  //     ns: 'becomeAuthorDetailsModal',
  //   }),
  //   'error-code:-39': t('messages.OTPTooManyRequests', {
  //     ns: 'becomeAuthorDetailsModal',
  //   }),
  // }

  const validationSchema = Yup.object({
    author_type: Yup.string().required(
      t('messages.authorType', { ns: 'author' })
    ),
    author_first_name: Yup.string().required(
      t('messages.authorFirstName', { ns: 'author' })
    ),
    author_last_name: Yup.string().required(
      t('messages.authorLastName', { ns: 'author' })
    ),
    author_organization: Yup.string().required(
      t('messages.authorOrganization', { ns: 'author' })
    ),
    author_URL: Yup.string()
      .matches(
        regexForUsername,
        t('specialSymbolsMessage', { ns: 'becomeAuthorDetailsModal' })
      )
      .min(4, t('messages.usernameLimitation', { ns: 'author' }))
      .required(t('messages.authorURL', { ns: 'author' })),
    // mobile: Yup.string().required('Phone is required'),
  })

  useEffect(() => {
    if (user?.username) {
      setIsUsernameAvailable(true)
    }
  }, [user])

  useEffect(() => {
    if (!secondsLeftBeforeNextResend) return
    const intervalId = setInterval(() => {
      setSecondsLeftBeforeNextResend(secondsLeftBeforeNextResend - 1)
    }, 1000)

    return () => clearInterval(intervalId)
  }, [secondsLeftBeforeNextResend])

  const handleDebouncedChange = debounce(async (value) => {
    // Do something with the debounced value here.
    if (value === user?.username) return setIsUsernameAvailable(true)
    setIsUsernameAvailable(false)
    setIsLoadingUsername(true)
    try {
      const res = await verifyAuthorUsername(value)

      if (res === 'OK') {
        if (value.length <= 4) {
          return setIsUsernameAvailable(false)
        }
        setIsUsernameAvailable(true)
      } else {
        setIsUsernameAvailable(false)
      }
      setIsLoadingUsername(false)
    } catch (e) {
      setIsUsernameAvailable(false)
    } finally {
      setIsLoadingUsername(false)
    }
  }, 800)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    if (value.length > 32) return
    if (value.trim().length <= 4) {
      setIsUsernameAvailable(false)
      setIsLoadingUsername(false)
      return
    }
    handleDebouncedChange(value.trim())
  }

  const handleSubmit = async (data: Values) => {
    // if ((mobile && mobile.toString().length < 7) || !mobile) {
    //   return setBottomNotification({
    //     message: t('invalidPhoneNumber', { ns: 'becomeAuthorDetailsModal' }),
    //     actionType: 'error',
    //   })
    // }
    if (!isAgreed) {
      return setBottomNotification({
        message: t('termsConditionError', { ns: 'becomeAuthorDetailsModal' }),
        actionType: 'error',
      })
    }

    const newData = {
      ...data,
      username: data.author_URL,
      author_type: instructorType ? 'organization' : 'individual',
      isAuthor: true,
    }

    delete newData.author_URL

    if (data.author_organization) {
      setIsLoading(true)
      UpdateUser(newData)
        .then(async (updatedUser) => {
          updateUser(updatedUser)
          setIsLoading(false)
          onClose()
          toaster({
            title: t('authorSuccess', { ns: 'becomeAuthorDetailsModal' }),
          })
          if (analytics)
            logEvent(analytics, 'user_become_author', {
              category: 'user_action',
              label: 'author_registration',
              value: 1,
            })
          // try {
          //   await handleSendOTP(('+' + mobile) as string)
          // } catch (error) {
          // } finally {
          //   setIsLoading(false)
          // }
        })
        .catch(() => {
          toaster({
            title: t('somethingWentWrong', { ns: 'becomeAuthorDetailsModal' }),
            type: 'error',
          })
          setIsLoading(false)
        })
    }
  }
  // const handleSendOTP = async (mobile: string) => {
  //   if (!mobile) return
  //   return new Promise<void>(async (resolve, reject) => {
  //     if (!appVerifier.current) {
  //       appVerifier.current = new RecaptchaVerifier(
  //         auth,
  //         'recaptcha-container',
  //         {
  //           size: 'invisible',
  //           callback: null,
  //           'expired-callback': () => {
  //             appVerifier.current?.clear()
  //           },
  //         }
  //       )
  //     }

  //     try {
  //       if (auth.currentUser) {
  //         const confirmationResult = await linkWithPhoneNumber(
  //           auth.currentUser,
  //           mobile,
  //           appVerifier.current
  //         )
  //         setIsOTPAvailable(true)
  //         setOtp('')
  //         setSecondsLeftBeforeNextResend(60)
  //         setBottomNotification({
  //           message: 'We have sent a verification code to your mobile number',
  //           actionType: 'success',
  //         })
  //         setFirebaseVerificationHandler(confirmationResult)
  //         resolve()
  //       }
  //     } catch (err: any) {
  //
  //       // appVerifier.current?.clear()
  //       setIsLoading(false)
  //       const pattern = /auth\/([a-zA-Z0-9_-]+)/
  //       setBottomNotification({
  //         message: OTPValidationErrorMsgs[err?.message?.match(pattern)?.[1]]
  //           ? OTPValidationErrorMsgs[err?.message?.match(pattern)?.[1]]
  //           : t('sendOTP500Message', { ns: 'becomeAuthorDetailsModal' }),
  //         actionType: 'error',
  //       })
  //       reject(err)
  //     }
  //   })
  // }
  // const handleVerifyOTP = async (e: FormEvent) => {
  //   e.preventDefault()
  //   setIsLoading(true)
  //   setIsInvalidOTP(false)
  //   try {
  //     if (firebaseVerificationHandler) {
  //       const confirmation = await firebaseVerificationHandler.confirm(otp)
  //       if (confirmation.user) {
  //         UpdateUser({ mobile: '+' + mobile, isAuthor: true }).then(
  //           (updatedUser) => {
  //             updateUser(updatedUser)
  //             onClose()
  //             setBottomNotification({
  //               message: 'Verified!',
  //               actionType: 'success',
  //             })
  //           }
  //         )
  //       }
  //     }
  //   } catch (err: any) {
  //     setOtp('')
  //     setIsInvalidOTP(true)
  //     const pattern = /auth\/([a-zA-Z0-9_-]+)/
  //     setBottomNotification({
  //       message:
  //         OTPValidationErrorMsgs[
  //           err?.message?.match(pattern)?.[1] || 'unknown'
  //         ],
  //       actionType: 'error',
  //     })
  //   }
  //   setIsLoading(false)
  // }
  // const handleResendOTP = async () => {
  //   await handleSendOTP('+' + mobile)
  // }

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          // isOTPAvailable ? onClose(true) :
          onClose()
          // setIsInvalidOTP(false)
        }}
        shouldBlockScroll={false}
        classNames={{ closeButton: 'mt-2 mr-2', backdrop: 'bg-uguPurple/40' }}
        isDismissable={false}
        // scrollBehavior="outside"
        placement="center"
        className="md:w-[30rem] lg:w-[46rem]"
      >
        <ModalContent
          style={{
            maxWidth:
              //  isOTPAvailable ? '23rem' :
              '46rem',
          }}
        >
          <ModalHeader style={{ marginBottom: 15 }} />
          <ModalBody style={{ padding: 0 }}>
            <Container
            //  style={{ display: !isOTPAvailable ? 'flex' : 'none' }}
            >
              <Left>
                <BecomeAuthor />
              </Left>
              <Right>
                <Heading>
                  {t('enterYourAuthorInformation', {
                    ns: 'becomeAuthorDetailsModal',
                  })}
                </Heading>
                <Formik
                  initialValues={initialValues}
                  onSubmit={handleSubmit}
                  validationSchema={validationSchema}
                >
                  {({ setValues, values, errors, touched, isValid, dirty }) => (
                    <Form>
                      <InputFieldWrapper>
                        <SwitchWrapper marginBottom={'6px'} marginLeft={'0px'}>
                          <Switch
                            size="sm"
                            onChange={(e) =>
                              setInstructorType(e.target.checked)
                            }
                            color="primary"
                            isDisabled={isLoading}
                          ></Switch>
                          <SwitchText>
                            {!instructorType
                              ? t('signUpAsIndividual', {
                                  ns: 'becomeAuthorDetailsModal',
                                })
                              : t('signUpAsOrganization', {
                                  ns: 'becomeAuthorDetailsModal',
                                })}
                          </SwitchText>
                        </SwitchWrapper>
                        <InputField>
                          <TextField
                            padding="0px 14px"
                            type="text"
                            id="author_first_name"
                            name="author_first_name"
                            maxLength="38"
                            error={
                              touched.author_first_name &&
                              errors.author_first_name
                            }
                            placeholder={
                              instructorType
                                ? t('organizationFirstName', {
                                    ns: 'becomeAuthorDetailsModal',
                                  })
                                : t('firstName', {
                                    ns: 'becomeAuthorDetailsModal',
                                  })
                            }
                            disabled={isLoading}
                          />
                          {touched.author_first_name && (
                            <Error>
                              <ErrorMessage name="author_first_name" />
                            </Error>
                          )}
                        </InputField>
                        <InputField>
                          <TextField
                            padding="0px 14px"
                            type="text"
                            id="author_last_name"
                            name="author_last_name"
                            error={
                              touched.author_last_name &&
                              errors.author_last_name
                            }
                            maxLength="38"
                            placeholder={
                              instructorType
                                ? t('organizationLastName', {
                                    ns: 'becomeAuthorDetailsModal',
                                  })
                                : t('lastName', {
                                    ns: 'becomeAuthorDetailsModal',
                                  })
                            }
                            disabled={isLoading}
                          />
                          {touched.author_last_name && (
                            <Error>
                              <ErrorMessage name="author_last_name" />
                            </Error>
                          )}
                        </InputField>
                        <SwitchWrapper marginBottom={'0px'} marginLeft={'0px'}>
                          <Checkbox
                            onChange={(e) => {
                              setValues((prev) => {
                                return {
                                  ...prev,
                                  author_organization: e.target.checked
                                    ? values.author_first_name &&
                                      values.author_last_name &&
                                      values.author_first_name +
                                        ' ' +
                                        values.author_last_name
                                    : '',
                                }
                              })
                            }}
                            color="primary"
                            size="md"
                            isDisabled={isLoading}
                          >
                            <SwitchText>
                              {instructorType
                                ? t('useOrganizationName', {
                                    ns: 'becomeAuthorDetailsModal',
                                  })
                                : t('usePersonalName', {
                                    ns: 'becomeAuthorDetailsModal',
                                  })}
                            </SwitchText>
                          </Checkbox>
                        </SwitchWrapper>

                        <InputField>
                          <TextField
                            padding="0px 14px"
                            type="text"
                            id="author_organization"
                            name="author_organization"
                            disabled={isLoading}
                            error={
                              touched.author_organization &&
                              errors.author_organization
                            }
                            maxLength="48"
                            placeholder={
                              instructorType
                                ? t('organizationNamePlaceholder', {
                                    ns: 'becomeAuthorDetailsModal',
                                  })
                                : t('instructorNamePlaceholder', {
                                    ns: 'becomeAuthorDetailsModal',
                                  })
                            }
                          />
                          {touched.author_organization && (
                            <Error>
                              <ErrorMessage name="author_organization" />
                            </Error>
                          )}
                        </InputField>

                        <div className="relative max-w-[20rem]">
                          <InputField>
                            <Field
                              type={'text'}
                              name="author_URL"
                              id="author_URL"
                            >
                              {({ field }: FieldProps) => {
                                return (
                                  <Input
                                    {...field}
                                    padding="0px 14px"
                                    width="20rem"
                                    onKeyUp={(e) => {
                                      handleChange(e)
                                      setValues((prev) => ({
                                        ...prev,
                                        author_URL: e.target.value,
                                      }))
                                    }}
                                    placeholder={t('usernamePlaceholder', {
                                      ns: 'becomeAuthorDetailsModal',
                                    })}
                                    error={
                                      (touched.author_URL &&
                                        errors.author_URL) ||
                                      (touched.author_URL &&
                                        !isUsernameAvailable)
                                    }
                                    disabled={isLoading}
                                    maxLength="32"
                                  />
                                )
                              }}
                            </Field>
                            {touched.author_URL && (
                              <Error>
                                <ErrorMessage name="author_URL" />
                              </Error>
                            )}
                            {touched.author_URL &&
                              !errors.author_URL &&
                              !isLoadingUsername &&
                              !isUsernameAvailable && (
                                <Error>
                                  {t('messages.usernameNotAvailable', {
                                    ns: 'author',
                                  })}
                                </Error>
                              )}
                          </InputField>
                          {!(touched.author_URL && errors.author_URL) && (
                            <div
                              className={`absolute ${
                                isLoadingUsername
                                  ? 'top-2.5'
                                  : isUsernameAvailable
                                    ? 'top-[0.58rem]'
                                    : 'top-[0.58rem]'
                              } right-2`}
                            >
                              {isLoadingUsername ? (
                                <Loader size="small" />
                              ) : isUsernameAvailable ? (
                                <CheckMarkIcon height="1.3rem" color="green" />
                              ) : (
                                <CrossCircleIcon height="1.3rem" color="red" />
                              )}
                            </div>
                          )}
                        </div>

                        {/* <InputField>
                          <PhoneInput
                            country={'us'}
                            value={''}
                            onChange={(phone) => setMobile(phone)}
                            containerClass={'containerClass'}
                            buttonClass={'buttonClass'}
                            inputClass={'inputClass'}
                            disabled={isLoading}
                          />
                        </InputField> */}
                        <SwitchWrapper marginBottom={'10px'} marginLeft={'0px'}>
                          <Checkbox
                            onChange={(e) => setIsAgreed(e.target.checked)}
                            color="primary"
                            size="md"
                            isDisabled={isLoading}
                          ></Checkbox>
                          <SwitchText>
                            {t('common.t&cMessage', { ns: 'author' })}{' '}
                            <a
                              href="/help-centre/legal/terms-and-conditions/"
                              target="_blank"
                              className="text-inherit"
                            >
                              <u>
                                <b>{t('common.t&c', { ns: 'author' })}</b>
                              </u>
                            </a>
                          </SwitchText>
                        </SwitchWrapper>
                        <Button
                          type="submit"
                          color="primary"
                          isLoading={isLoading}
                          size="lg"
                          isDisabled={
                            !isAgreed ||
                            // !(mobile && mobile?.toString().length >= 11) ||
                            !(isValid && dirty)
                          }
                          className="self-center font-semiBold"
                        >
                          {t('buttons.becomeAuthor', { ns: 'author' })}
                        </Button>
                      </InputFieldWrapper>
                    </Form>
                  )}
                </Formik>
              </Right>
            </Container>
            {/* <OtpContainer
              style={{ display: isOTPAvailable ? 'inline' : 'none' }}
            >
              <Heading>{t('messages.verifyTitle')}</Heading>
              <div className="mb-[1rem]">
                <Text>{t('messages.verifyDesc')}</Text>
                <Text>{t('messages.verifyLabel')}</Text>
              </div>
              {isOTPAvailable && (
                <form onSubmit={handleVerifyOTP}>
                  <div
                    className={`flex justify-center mb-[2rem] ${
                      isInvalidOTP ? 'animate-shaking-x' : ''
                    }`}
                  >
                    <OtpInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={6}
                      shouldAutoFocus={true}
                      inputType="number"
                      renderSeparator={<span style={{ width: '18px' }}></span>}
                      renderInput={(props) => <OtpInputField {...props} />}
                    />
                  </div>
                  <div className="flex justify-center mb-[1rem]">
                    <Button
                      type="submit"
                      className="mx-auto font-semiBold px-8"
                      color="primary"
                      isLoading={isLoading}
                      isDisabled={isLoading || otp.length !== 6}
                    >
                      {t('Verify')}
                    </Button>
                  </div>
                </form>
              )}
              <div
                className="flex flex-row align-center justify-evenly mx-auto"
                style={{ maxWidth: '200px' }}
              >
                <CButton
                  disabled={!!secondsLeftBeforeNextResend}
                  onClick={handleResendOTP}
                  color="primary"
                  className="self-center font-semiBold"
                >
                  <Text>
                    <b style={{ cursor: 'pointer' }}>
                      <u>
                        Resend code
                        {secondsLeftBeforeNextResend !== 0 &&
                          `(${secondsLeftBeforeNextResend})`}
                      </u>
                    </b>
                  </Text>
                </CButton>
                <CButton
                  color="primary"
                  className="self-center font-semiBold"
                  onClick={() => {
                    setIsOTPAvailable(false)
                    setIsInvalidOTP(false)
                  }}
                >
                  <Text>
                    <b style={{ cursor: 'pointer' }}>
                      <u>{t('messages.goBack')}</u>
                    </b>
                  </Text>
                </CButton>
              </div>
            </OtpContainer> */}
          </ModalBody>
        </ModalContent>
      </Modal>
      {bottomNotification && (
        <PopUpBottom
          bottomNotification={bottomNotification as BottomNotification}
          setShowPopUp={setBottomNotification}
        />
      )}
    </>
  )
}
export default AuthorDetailsModal
